<div class="sections-container">

  <!-- Leiste über den Grafiken. Ihre Knöpfe gelten für alle Zeilen DIESES Reiters –
       nicht für das ganze Dokument: jeder Reiter ist ein anderer Zeitpunkt. Dieselben
       Knöpfe stehen an jeder Zeilenüberschrift und wirken dort nur auf ihre Karten;
       den Unterschied macht der [umfang]. -->
  @if (toolbar; as tb) {
    <app-graphic-toolbar [title]="tb.title" [actions]="tb.actions"
      [reiter]="tab.caption ?? ''"
      [umfang]="umfangDesReiters()"
      [showZoom]="hasMapSections()"></app-graphic-toolbar>
  }

  @for (section of tab.containerList; track $index) {
    <div class="section" [style]="isMobileScreen() ? null : section?.inlineStyle"
      >
      @if (sectionHasDivider(section)) {
        <app-divider></app-divider>
      }
      @if (section.containerType !== 'Tab') {
        <div>
          @if (section.containerType === 'KiButton') {
            @if (layoutElementUtil.isKiButton(section)) {
              <div class="input-component-textareacopy-container">
                <app-ki-button [kiButtonMappings]="layoutElementUtil.asKiButton(section).kiButtonMappings"></app-ki-button>
              </div>
            }
          } @else {
            @if (isMapSectionCaption(section)) {
              <div class="map-section-header">
                <h3 class="map-section-caption">{{ section.caption }}</h3>
                <!-- Zoom-Regler auch hier, damit man beim Herunterscrollen nicht nach
                     oben muss. Alle Instanzen hängen am selben Service, zeigen also
                     denselben Wert und verstellen ihn gemeinsam. -->
                <app-karten-zoom [kompakt]="true"></app-karten-zoom>
                <!-- "leeren" an JEDER Karten-Zeile, nicht nur im Reiter "Heute".
                     Die frühere Einschränkung stammte aus der Zeit, als der Knopf die
                     ganze Seite geleert hat – da hätte ein zweiter nichts anderes
                     bewirkt. Seit er nur die Karten seiner eigenen Zeile leert, gehört
                     er an jede Zeile. -->
                <button type="button" class="dmx-pill-button dmx-pill-button--kompakt"
                  [attr.title]="'Karten der Zeile \'' + section.caption + '\' leeren'"
                  (click)="onClearBoxes(section)">
                  <mat-icon>highlight_off</mat-icon>
                  <span>leeren</span>
                </button>
                <!-- "KI-Auswahl aufheben": alle gelben Kästchen der Karten DIESER Zeile
                     abhaken, Werte bleiben stehen. Rechts neben "leeren", gleicher Umfang. -->
                <button type="button" class="dmx-pill-button dmx-pill-button--kompakt"
                  [attr.title]="'Alle gelben KI-Kästchen der Zeile \'' + section.caption + '\' abwählen – die Werte bleiben'"
                  (click)="onKiAuswahlAufheben(section)">
                  <mat-icon>remove_done</mat-icon>
                  <span>KI-Auswahl aufheben</span>
                </button>
                <!-- Derselbe Knopfsatz wie in der Leiste oben, aber mit den
                     containerIds NUR dieser Zeile: "KI-Texte erzeugen" nimmt hier
                     ausschließlich die angehakten Boxen dieser Karten, "MSWR-MOS laden"
                     füllt nur sie. Die Leiste oben schickt keine Ids und gilt damit für
                     alle Zeilen. -->
                @if (toolbar; as tb) {
                  <app-graphic-toolbar class="map-section-toolbar"
                    [actions]="tb.actions" [kompakt]="true"
                    [reiter]="tab.caption ?? ''"
                    [umfang]="umfangVon(section)"></app-graphic-toolbar>
                }
              </div>
              <!-- Die KI-Antwort dieser Zeile, direkt über ihren Karten. Steht bewusst
                   außerhalb der Überschriftszeile: sie ist ein Block, kein Knopf. -->
              <app-ki-ergebnis-box [umfang]="umfangVon(section)"></app-ki-ergebnis-box>
              <!-- Was "MSWR-MOS laden" dieser Zeile geladen hat: Datenquellen und Stand. -->
              <app-lade-quellen-box [umfang]="umfangVon(section)"></app-lade-quellen-box>
            } @else {
              <h3>{{ section.caption }}</h3>
            }
            <div class="input-component-container"
              [class.map-row]="isMapSectionCaption(section)"
              [class.map-row--tv]="hatTvGruppe(section)"
              [class.map-row--tv-knopf]="hatTvKnopf(section)">
              <!-- INPUT KOMPONENTE -->
              @for (container of section.containerList; track $index) {
                @if (layoutElementUtil.isTerminalLabel(container)) {
                  <div class="terminal-list-row-item-input">
                    <app-terminal-label [label]="container"></app-terminal-label>
                  </div>
                }
                @if (layoutElementUtil.isTextArea(container)) {
                  <div class="input-component">
                    <app-text-area [textArea]="layoutElementUtil.asTextArea(container)"></app-text-area>
                  </div>
                }
                @if (layoutElementUtil.isPopnachtTextTextArea(container)) {
                  <div class="input-component">
                    <app-ard-popnacht-text-area
                      [textArea]="layoutElementUtil.asPopnachtTextArea(container)"
                      (copyEvent)="getMouseEvent($event, section, container)"
                      [copyFromIds]="layoutElementUtil.asPopnachtTextArea(container).copyFromIds"
                      >
                    </app-ard-popnacht-text-area>
                  </div>
                }
                @if (layoutElementUtil.isTextAreaContainer(container)) {
                  <div class="input-component-textarea-container">
                    <app-text-area-container [textAreaContainer]="layoutElementUtil.asTextAreaContainer(container)"></app-text-area-container>
                  </div>
                }
                @if (layoutElementUtil.isTextAreaCopyContainer(container)) {
                  <div class="input-component-textareacopy-container">
                    <app-text-area-copy-container [textAreaCopyContainer]="layoutElementUtil.asTextAreaCopyContainer(container)"
                      [copyToIds]="layoutElementUtil.asTextAreaCopyContainer(container).copyToIds"
                      (copyEvent)="getACEvent($event)">
                    </app-text-area-copy-container>
                  </div>
                }
                <!--        <div class="input-component videotext" *ngIf="layoutElementUtil.isVideoTextArea(container)">-->
                <!--          <app-video-text-area [videoTextArea]="container"></app-video-text-area>-->
              <!--        </div>-->
              @if (layoutElementUtil.isComboBox(container)) {
                <div>
                  <app-combo-box [comboBox]="layoutElementUtil.asComboBox(container)"></app-combo-box>
                </div>
              }
              @if (layoutElementUtil.isTerminalList(container)) {
                <div class="input-component">
                  <app-terminal-list
                    [style]="container.inlineStyle ? layoutElementUtil.translateStyle(container.inlineStyle) : null"
                  [terminalList]="container"></app-terminal-list>
                </div>
              }
              @if (layoutElementUtil.isTextField(container)) {
                <div class="input-component field">
                  <app-text-field [textField]="layoutElementUtil.asTextField(container)"></app-text-field>
                </div>
              }
              @if (layoutElementUtil.isDateTimePicker(container)) {
                <div class="input-component field">
                  <app-datetime-picker [showDefaultTime]="true"
                  [(date)]="layoutElementUtil.asDateTimeTextField(container).dateContent"></app-datetime-picker>
                </div>
              }
              @if (layoutElementUtil.isFileUpload(container)) {
                <div class="input-component">
                  <app-file-upload [fileUpload]="container"></app-file-upload>
                </div>
              }
              @if (layoutElementUtil.isImage(container)) {
                <div class="input-component"
                  [style]="container.inlineStyle ? layoutElementUtil.translateStyle(container.inlineStyle) : null">
                  <!-- TV-Relevanz (Oktober 2026): aufeinanderfolgende Karten mit `tvRelevanz` aus dem
                       Template bekommen einen lila Rahmen mit Überschrift. Die Karten bleiben direkte
                       Kinder der Reihe (ihre Breite ist ein Prozentmaß der Reihe – in einem Wrapper
                       kollabierte sie); der Rahmen ist ein Overlay in der ERSTEN Karte der Gruppe,
                       so breit wie alle Karten der Gruppe zusammen (tvBreite), ohne Mausereignisse. -->
                  @if (tvGruppeAb(section, container); as gruppe) {
                    <div class="tv-relevanz" [style.width]="tvBreite(gruppe)" [attr.title]="tvTitel(gruppe)">
                      <span class="tv-relevanz__titel">TV-Relevanz</span>
                      <!-- "Höchstwerte übernehmen": nur in HEUTE: Nachmittag (NRW) und MORGEN: Nachmittag
                           (Lokalzeiten) – kopiert die Temperaturen der gleichen Karten aus der Zeile "ganz". -->
                      @if (zeigtHoechstwerte(gruppe)) {
                        <button type="button" class="dmx-pill-button tv-relevanz__knopf"
                          title="Die Tageshöchstwerte aus der Zeile 'ganz' dieses Reiters in diese Karten übernehmen (nur Temperaturen, Box für Box)"
                          (click)="onHoechstwerte($event, gruppe)">
                          <span>Höchstwerte übernehmen</span>
                        </button>
                      }
                    </div>
                  }
                  <app-image [image]="layoutElementUtil.asImage(container)"></app-image>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
</div>
